import React, { Fragment, FunctionComponent, useCallback, useState } from "react";
import styles from "./Sidemenu.module.scss";
import SidemenuContent from "./SidemenuContent.model";

import { CLOSE_ALL_OVERLAYS } from "layout/redux/overlay.actions";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import combineClasses from "helpers/combine-classes";
import Dictionary from "components/Dictionary/Dictionary";
import IconViewer from "components/IconViewer/IconViewer";
import useCategoriesMapping from "./hooks/useCategoriesMapping";

const Sidemenu: FunctionComponent<SidemenuContent> = (props) => {
    const categories: any[] = useCategoriesMapping();

    const viewClass = styles[`view_${props.view}`];

    const dispatch = useDispatch();

    const closeOverlay = useCallback(() => {
        dispatch({
            type: CLOSE_ALL_OVERLAYS
        });
    }, [dispatch]);

    const onTagButtonClick = useCallback((id: string) => {
        let result: string[] = JSON.parse(JSON.stringify(props.tags));
        const existingFacet = result.find(x => x === id);

        if (!existingFacet) {
            result.push(id);
        }
        else {
            result = result.filter(x => x !== id);
        }

        if (typeof (props.onTagsChange) !== "undefined") {
            props.onTagsChange(result);
        }
    }, [props.onTagsChange]);

    return (
        <Fragment>
            {props.view === "FULL" ? <Helmet bodyAttributes={{ class: "is-locked" }} /> : null}

            <div className={combineClasses([styles.wrapper, viewClass])}>
                {categories && categories.length > 0 ? (
                    <div className={styles.menu}>
                        {props.view === "FULL" ? (
                            <button className={styles.close_button} onClick={() => closeOverlay()}>
                                <IconViewer className={styles.close_icon} name="close" />
                            </button>
                        ) : null}

                        <div className={styles.facets}>
                            <Fragment>
                                {categories?.map((mainCategory: any, index: number) => {
                                    return (
                                        <Fragment key={`m_${index}`}>
                                            {mainCategory.subCategories && mainCategory.subCategories.length > 0 ? (
                                                <Fragment>
                                                    <strong className={styles.facet_headline}>{mainCategory.category.primaryTitle}</strong>

                                                    {mainCategory.subCategories?.map((subCategory: any, subIndex: number) => {
                                                        return (
                                                            <button key={`sm_${subIndex}`} className={styles.facet_button} onClick={() => onTagButtonClick(subCategory.category.id)}>
                                                                {props.tags.includes(subCategory.category.id) ? (
                                                                    <IconViewer className={styles.facet_button_icon} name="close" />
                                                                ) : null}
                                                                {subCategory.category.primaryTitle}
                                                            </button>
                                                        );
                                                    })}
                                                </Fragment>
                                            ) : null}
                                        </Fragment>
                                    );
                                })}

                                <strong className={styles.facet_headline}>
                                    <Dictionary name="MEDIA_CLOUD.MATERIALS_HEADLINE" />
                                    <button className={styles.facet_button} onClick={() => onTagButtonClick("MATERIAL_SIGN")}>
                                        {props.tags.includes("MATERIAL_SIGN") ? (
                                            <IconViewer className={styles.facet_button_icon} name="close" />
                                        ) : null}
                                        <Dictionary name="MEDIA_CLOUD.SIGN" />
                                    </button>
                                    <button className={styles.facet_button} onClick={() => onTagButtonClick("MATERIAL_PICTURE")}>
                                        {props.tags.includes("MATERIAL_PICTURE") ? (
                                            <IconViewer className={styles.facet_button_icon} name="close" />
                                        ) : null}
                                        <Dictionary name="MEDIA_CLOUD.PICTURE" />
                                    </button>
                                </strong>
                            </Fragment>
                        </div>
                    </div>
                ) : null}
            </div>
        </Fragment>
    );
};

export default Sidemenu;